import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Element } from 'react-scroll';
import { getFormMeta } from 'redux-form';
import { propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
const ArrayFieldsAndLabel = (props) => {
    const { addObject, description, descriptionClassName, fields, form, heading, isRequired, isSubmitFailed, render, subDescription, } = props;
    const onClickPush = useCallback(() => {
        fields.push(addObject);
    }, [fields, addObject]);
    const onClickDelete = useCallback((e) => {
        const index = parseInt(e.currentTarget.value, 10);
        fields.remove(index);
        if (fields.length === 1) {
            onClickPush();
        }
    }, [fields, onClickPush]);
    const globalError = useSelector((state) => _.get(getFormMeta(form)(state), `${fields.name}._error`));
    return (_jsxs("div", Object.assign({ className: `form form-solution ${isRequired ? 'req' : ''}` }, { children: [_jsx(Element, { name: fields.name }), _jsxs("h3", { children: [heading, description && (_jsx("small", Object.assign({ className: descriptionClassName }, { children: description })))] }), subDescription && (_jsx("div", Object.assign({ className: 'profile_sub_description' }, { children: _jsx("div", Object.assign({ className: 'form_sub_text' }, { children: subDescription })) }))), fields.map((field, index) => render({
                field,
                index,
                isOneLength: fields.length === 1,
                onClickDelete,
            })), _jsx("button", Object.assign({ className: 'btn btn-default small wide', onClick: onClickPush, type: 'button' }, { children: "\u8FFD\u52A0\u3059\u308B" })), isSubmitFailed && _jsx(InputError, { className: 'mt1', error: globalError })] })));
};
ArrayFieldsAndLabel.propTypes = {
    addObject: propShape().isRequired,
    description: propStr(),
    descriptionClassName: propStr(),
    fields: propShape().isRequired,
    form: propStr().isRequired,
    heading: propStr().isRequired,
    isRequired: propBool().isRequired,
    isSubmitFailed: propBool().isRequired,
    render: propFunc().isRequired,
    subDescription: propStr(),
};
ArrayFieldsAndLabel.defaultProps = {
    description: undefined,
    descriptionClassName: undefined,
    subDescription: undefined,
};
export default ArrayFieldsAndLabel;
